import { useEffect, useState } from "react";
import "./style.scss";
import TextInput from "@builder/components/general/TextInput";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { ActionType } from "@common/build/types";
import { ActionEditorItem, updateStepperActions } from "@builder/store/slices/actionBuilderSlice";

const Confirmation = () => {
    const { id } = useAppSelector(state => state.actionBuilder.current);
    const actionStep = useAppSelector(state => state.actionBuilder.actionsEditor.find(item => item.id === id));
    const dispatch = useAppDispatch();
    const [message, setMessage] = useState<string>(actionStep?.action?.message || "");

    useEffect(() => {
        if (message) {
            const action = { type: ActionType.CONFIRMATION, message };
            const updatedStep = { ...actionStep };
            updatedStep.action = { ...action };
            if (JSON.stringify(updatedStep) !== JSON.stringify(actionStep)) {
                dispatch(updateStepperActions({ id: id, item: updatedStep as ActionEditorItem }));
            }
        }
    }, [message, actionStep, dispatch, id]);
    return (
        <div className="confirmation-wrapper">
            <TextInput
                title="User prompt"
                callback={setMessage}
                value={message}
                className="actions-tab-input"
                placeholder="Are you sure you want to proceed?"
            />
        </div>
    );
};

export default Confirmation;
